/**
 * App Language Provider
 * Add more locales here
 */
import { addLocaleData } from "react-intl";
import enLang from "./entries/en-US";
import esLang from "./entries/es-ES";
import brLang from "./entries/pt-BR";
import deLang from "./entries/de-de";

const AppLocale = {
  "en-US": enLang,
  "es-ES": esLang,
  "pt-BR": brLang,
  "de-de": deLang
};

addLocaleData(AppLocale["en-US"].data);
addLocaleData(AppLocale["es-ES"].data);
addLocaleData(AppLocale["pt-BR"].data);
addLocaleData(AppLocale["de-de"].data);

export default AppLocale;
